module.exports = __webpack_public_path__ + "img/photo.0d997e44.svg";